export default {"src":"/_next/static/media/work_chat.5387ea6b.svg","height":569,"width":949};